import { z } from 'my-zod'

export const operatorReview = z.object({
  operatorId: z.number(),
  starRating: z.number(),
  numberOfReviews: z.number()
})

export type operatorReview = z.infer<typeof operatorReview>
